module.exports = __webpack_public_path__ + "img/inviteFlowChart.ded88d85.png";